import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, unref as _unref, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "emp-detail-modal"
}
const _hoisted_2 = { class: "emp-detail-header" }
const _hoisted_3 = { class: "emp-info" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "emp-select emp-name-only"
}
const _hoisted_6 = {
  key: 2,
  class: "emp-join"
}
const _hoisted_7 = { class: "emp-detail-body" }
const _hoisted_8 = { class: "emp-box settings-box" }
const _hoisted_9 = { class: "settings-grid" }
const _hoisted_10 = {
  key: 0,
  class: "setting-check"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "setting-check" }
const _hoisted_13 = {
  key: 0,
  class: "lunch-expense-warning"
}
const _hoisted_14 = { class: "setting-check" }
const _hoisted_15 = { class: "emp-input-row" }
const _hoisted_16 = { class: "emp-box input-box work-info" }
const _hoisted_17 = { class: "box-title box-title--with-action" }
const _hoisted_18 = {
  key: 0,
  class: "min-wage-inline"
}
const _hoisted_19 = {
  key: 0,
  class: "wage-basic-calc-mode",
  role: "group",
  "aria-label": "기본급 산출 방식"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "input-table" }
const _hoisted_23 = { class: "wage-input-cell hourly-wage-item" }
const _hoisted_24 = { class: "wage-input-wrapper" }
const _hoisted_25 = ["value"]
const _hoisted_26 = ["value", "disabled"]
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "emp-box input-box allowance-info" }
const _hoisted_31 = { class: "input-table" }
const _hoisted_32 = { class: "nontax-row" }
const _hoisted_33 = {
  key: 0,
  class: "lunch-warning"
}
const _hoisted_34 = { class: "warning-text" }
const _hoisted_35 = { class: "emp-box result-box-new" }
const _hoisted_36 = { class: "result-header" }
const _hoisted_37 = { class: "adjust-tags" }
const _hoisted_38 = { class: "tag total-tag" }
const _hoisted_39 = { class: "tag" }
const _hoisted_40 = { class: "tag" }
const _hoisted_41 = { class: "result-table" }
const _hoisted_42 = ["value", "disabled"]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 0,
  class: "nontax-row"
}
const _hoisted_45 = { class: "nontax-row" }
const _hoisted_46 = { class: "emp-deduct-settings" }
const _hoisted_47 = { class: "emp-two-col" }
const _hoisted_48 = { class: "emp-box deduct-box" }
const _hoisted_49 = { class: "deduct-edit-grid" }
const _hoisted_50 = { class: "deduct-edit-row" }
const _hoisted_51 = { class: "deduct-label" }
const _hoisted_52 = ["checked"]
const _hoisted_53 = {
  key: 0,
  class: "age-exempt-badge"
}
const _hoisted_54 = {
  key: 1,
  class: "age-auto-badge"
}
const _hoisted_55 = ["value"]
const _hoisted_56 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_57 = { class: "deduct-edit-row" }
const _hoisted_58 = { class: "deduct-label" }
const _hoisted_59 = ["checked"]
const _hoisted_60 = ["value"]
const _hoisted_61 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_62 = { class: "deduct-edit-row" }
const _hoisted_63 = { class: "deduct-label" }
const _hoisted_64 = ["checked"]
const _hoisted_65 = ["value"]
const _hoisted_66 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_67 = { class: "deduct-edit-row" }
const _hoisted_68 = { class: "deduct-label" }
const _hoisted_69 = ["checked"]
const _hoisted_70 = {
  key: 0,
  class: "age-exempt-badge"
}
const _hoisted_71 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_72 = { class: "deduct-edit-row" }
const _hoisted_73 = { class: "deduct-label" }
const _hoisted_74 = ["checked"]
const _hoisted_75 = {
  key: 0,
  class: "age-exempt-badge"
}
const _hoisted_76 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_77 = { class: "deduct-edit-row" }
const _hoisted_78 = { class: "deduct-label" }
const _hoisted_79 = ["checked"]
const _hoisted_80 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_81 = { class: "deduct-edit-row" }
const _hoisted_82 = { class: "deduct-label" }
const _hoisted_83 = ["checked"]
const _hoisted_84 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_85 = { class: "deduct-edit-row" }
const _hoisted_86 = { class: "deduct-label" }
const _hoisted_87 = ["checked"]
const _hoisted_88 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_89 = { class: "deduct-edit-row" }
const _hoisted_90 = { class: "deduct-label" }
const _hoisted_91 = ["checked"]
const _hoisted_92 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_93 = { class: "deduct-edit-row" }
const _hoisted_94 = { class: "deduct-edit-row" }
const _hoisted_95 = { class: "deduct-total" }
const _hoisted_96 = { class: "emp-box deduct-box" }
const _hoisted_97 = { class: "deduct-edit-grid" }
const _hoisted_98 = { class: "deduct-edit-row" }
const _hoisted_99 = { class: "deduct-label" }
const _hoisted_100 = ["checked"]
const _hoisted_101 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_102 = { class: "deduct-edit-row" }
const _hoisted_103 = { class: "deduct-label" }
const _hoisted_104 = ["checked"]
const _hoisted_105 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_106 = { class: "deduct-edit-row" }
const _hoisted_107 = { class: "deduct-label" }
const _hoisted_108 = ["checked"]
const _hoisted_109 = {
  key: 1,
  class: "deduct-auto-value"
}
const _hoisted_110 = { class: "deduct-total" }
const _hoisted_111 = {
  class: "emp-box",
  style: {"margin-top":"8px"}
}
const _hoisted_112 = { class: "emp-summary" }
const _hoisted_113 = { class: "summary-item total" }
const _hoisted_114 = { class: "summary-item minus" }
const _hoisted_115 = { class: "summary-item net" }
const _hoisted_116 = { class: "emp-detail-footer" }
const _hoisted_117 = { class: "footer-left" }
const _hoisted_118 = ["disabled"]
const _hoisted_119 = { class: "footer-right" }
const _hoisted_120 = ["disabled"]

import { ref, computed, watch, nextTick } from 'vue';
import { commonWageApi } from '@/services/api';
import CommonWageHourlyInput from '@/components/wage/common/CommonWageHourlyInput.vue';
import CommonWageDetailBoard from '@/components/wage/common/CommonWageDetailBoard.vue';
import HomeWageDeductionFixModal from '@/components/wage/home/HomeWageDeductionFixModal.vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import {
  COMMON_WAGE_INSURANCE_SHARED,
} from '@/policies/commonWagePayrollFields';
import type { CommonWageListRow, CommonWageTaxRate } from '@/types/commonWage';
import {
  formatWageNumber,
  parseWageNumber,
  parseHours,
  sanitizeHoursInput,
  normalizeHoursInputValue,
  formatHoursDisplay,
  validateAgeInsurance,
  validateProductionWorkerNontax,
  validateLunchExpense,
  clampNontaxCashFieldInput,
  isProductionWorkerPosition,
} from '@/composables/wage/useWageCalculator';
import { truncateWageOnes } from '@/policies/wageOnesTruncatePolicy';
import {
  computeCommonWageDetail,
  computeCommonWageDetailForDisplay,
  computeCommonWageDetailForSave,
  previewCommonWageDeductionFix,
  taxRateInfoToRates,
  defaultProductionNontax,
  applyWageAmountOverrides,
  WAGE_AMOUNT_MANUAL_FLAG_BY_CALC_KEY,
  WAGE_HOURS_DERIVED_CALC_KEYS,
  stripHoursDerivedManualFlags,
  type IncomeTaxRow,
  type CommonWageCalcResult,
  type CommonWageManualFlags,
  type CommonWageDeductForm,
  type CommonWageSettings,
  type CommonWageCalcInput,
} from '@/composables/wage/useCommonWageCalc';
import type { CcwdFormInputField } from '@/constants/commonWageFields';
import { rowEmpKey, resolveAuthoritativeBirth } from '@/utils/empMatchKey';
import {
  createEmptyFormStrings,
  rowToFormStrings,
  getRowToFormDefaultOptions,
  rowToDeductNumbers,
  rowToSettings,
  calcToDeductNumbers,
  buildSavePayload,
  emptyDeductNumbers,
  formStringsToNumbers,
  inferWorkDaysFromHours,
  rowToCalcSnapshot,
  parseManualFlagsFromRow,
  type CommonWageFormStrings,
} from '@/utils/commonWageMapper';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageEditModal',
  props: {
    show: { type: Boolean },
    row: {},
    employees: {},
    mCode: {},
    year: {},
    month: {},
    bizGubun: {},
    minHourlyWage: {},
    taxRateInfo: {},
    inline: { type: Boolean, default: false },
    autoCalcMode: { type: Boolean, default: true },
    basicCalcModeAllowed: { type: Boolean, default: false },
    defaultWorkDays: { default: null }
  },
  emits: ["close", "saved", "deleted", "change", "hydrated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const isPanelActive = computed(() => (props.inline ? !!props.row : props.show));

const outerBind = computed(() => {
  if (props.inline) {
    return { class: 'emp-detail-inline-root' };
  }
  return {
    modelValue: props.show,
    maxWidth: 920,
    persistent: true,
    scrollable: true,
  };
});

const emit = __emit;

/** DB/연월 로드·자동계산 중 — blur 등으로 change가 올라가지 않도록 */
const suppressChangeNotify = ref(false);

const notifyChange = () => {
  if (suppressChangeNotify.value || saving.value || deleting.value) return;
  emit('change');
};

const saving = ref(false);
const deleting = ref(false);
const calculating = ref(false);
/** DB 저장값 로드 후 — 자동 재계산이 저장값을 덮어쓰지 않도록 */
const payrollDbLock = ref(false);
/** 「계산」 버튼으로 스냅샷 확정 여부 (저장 전 필수) */
const payrollCalcConfirmed = ref(false);
const skipCalcConfirmReset = ref(false);
const autoCalcSyncing = ref(false);
/** 자동계산 모드 — 2-pass 계산 결과 (「계산」 버튼과 동일) */
const autoCalcSnapshot = ref<CommonWageCalcResult | null>(null);
/** 근무·수당 금액 수동 입력값 */
const calcAmountOverrides = ref<Partial<Record<string, number>>>({});
const incomeTaxTable = ref<IncomeTaxRow[]>([]);
const incomeTaxYearNote = ref('');

const settings = ref<Pick<CommonWageSettings, 'cwhd_production_nontax' | 'cwhd_lunch_expense' | 'cwhd_is_owner'>>({
  cwhd_production_nontax: false,
  cwhd_lunch_expense: false,
  cwhd_is_owner: false,
});

const manualFlags = ref<CommonWageManualFlags>({});
const prevMonthLunch = ref<number | null>(null);
const lunchValidation = ref<ReturnType<typeof validateLunchExpense> | null>(null);

/** 기본급 산출 방식 — 시급×시간(기본) 또는 기본급→시간 역산 */
const basicCalcMode = ref<'hourly' | 'basic'>('hourly');

const deductForm = ref<CommonWageDeductForm>(emptyDeductNumbers());

const selectedEmpKey = ref<string | null>(null);
const currentRow = ref<CommonWageListRow | null>(null);

const employeeOptions = computed(() => props.employees?.length ? props.employees : props.row ? [props.row] : []);
const employeeName = computed(() => currentRow.value?.ce_name || '');
const employeeBirthDate = computed(
  () => currentRow.value?.ce_birth_date || currentRow.value?.cwhd_birth || null
);
const year = computed(() => props.year);
const month = computed(() => props.month);

function onEmployeeSelectChange() {
  const emp = employeeOptions.value.find((e) => rowEmpKey(e) === selectedEmpKey.value);
  if (emp) {
    currentRow.value = emp;
    void hydrateFormFromRow(emp);
  }
}

const showProductionWorkerOption = computed(() => {
  const pos = currentRow.value?.ce_position;
  return isProductionWorkerPosition(pos) || settings.value.cwhd_production_nontax;
});

const form = ref<CommonWageFormStrings>(createEmptyFormStrings());
/** 달력 영업일로 채운 값. 사용자가 고치면 null */
const autoFilledWorkDays = ref<number | null>(null);
const workDaysTouched = ref(false);

const emptyCalc = (): CommonWageCalcResult => ({
  cwhd_basic: 0,
  overtimeTotal: 0,
  nightTotal: 0,
  holidayTotal: 0,
  cwhd_overtime: 0,
  cwhd_night: 0,
  cwhd_holiday: 0,
  cwhd_overtime_nontax: 0,
  cwhd_night_nontax: 0,
  cwhd_holiday_nontax: 0,
  cwhd_wage_total: 0,
  cwhd_taxable: 0,
  cwhd_usual: 0,
  cwhd_l_yeon: 0,
  cwhd_l_gun: 0,
  cwhd_l_jang: 0,
  cwhd_l_go: 0,
  cwhd_l_so: 0,
  cwhd_l_ji: 0,
  cwhd_l_jiwon: 0,
  cwhd_l_sik: 0,
  cwhd_l_etc: 0,
  cwhd_l_yearend: 0,
  cwhd_l_total: 0,
  cwhd_c_yeon: 0,
  cwhd_c_gun: 0,
  cwhd_c_jang: 0,
  cwhd_c_go: 0,
  cwhd_c_sil: 0,
  cwhd_c_san: 0,
  cwhd_c_out: 0,
  cwhd_c_total: 0,
  netPay: 0,
});

const dbCalcSnapshot = ref<CommonWageCalcResult>(emptyCalc());

const fallbackCalc = computed((): CommonWageCalcResult => {
  const parsed = formStringsToNumbers(form.value);
  const hourly = parsed.cwhd_pay_calc_hourly;
  const overtimeTotal = truncateWageOnes(
    hourly * parsed.cwhd_overtime_hours * 1.5,
    props.year,
    props.month
  );
  const nightTotal = truncateWageOnes(hourly * parsed.cwhd_night_hours * 0.5, props.year, props.month);
  const holidayTotal = truncateWageOnes(
    hourly * parsed.cwhd_holiday_hours * 1.5,
    props.year,
    props.month
  );
  const cwhd_basic = basicCalcMode.value === 'basic' && calcAmountOverrides.value.cwhd_basic != null
    ? calcAmountOverrides.value.cwhd_basic
    : truncateWageOnes(hourly * parsed.cwhd_work_hours, props.year, props.month);
  const cwhd_wage_total =
    cwhd_basic +
    overtimeTotal +
    nightTotal +
    holidayTotal +
    parsed.cwhd_dayoff +
    parsed.cwhd_senior +
    parsed.cwhd_sunim +
    parsed.cwhd_bonus +
    parsed.cwhd_bosu +
    parsed.cwhd_bojon +
    parsed.cwhd_other +
    parsed.cwhd_dang +
    parsed.cwhd_lunch +
    parsed.cwhd_car +
    parsed.cwhd_child;
  return {
    ...emptyCalc(),
    cwhd_basic,
    overtimeTotal,
    nightTotal,
    holidayTotal,
    cwhd_overtime: overtimeTotal,
    cwhd_night: nightTotal,
    cwhd_holiday: holidayTotal,
    cwhd_wage_total,
    cwhd_taxable: cwhd_wage_total,
    cwhd_usual: cwhd_basic,
    netPay: cwhd_wage_total,
  };
});

const buildCalcInput = (): CommonWageCalcInput => ({
  form: {
    ...formStringsToNumbers(form.value),
    // 기본급→시간 모드에서는 수동 입력 기본급을 계산에 반영
    ...(basicCalcMode.value === 'basic' && calcAmountOverrides.value.cwhd_basic != null
      ? { cwhd_basic: calcAmountOverrides.value.cwhd_basic }
      : {}),
  },
  settings: {
    ...settings.value,
    manualFlags: manualFlags.value,
    deductForm: deductForm.value,
  },
  taxRates: taxRateInfoToRates(props.taxRateInfo!),
  incomeTaxTable: incomeTaxTable.value,
  birthDate: employeeBirthDate.value,
  year: props.year,
  month: props.month,
  rowContext: {
    ce_join_date: currentRow.value?.ce_join_date,
    ce_leave_date: currentRow.value?.ce_leave_date,
    is_month_enter: currentRow.value?.is_month_enter,
    is_month_leave: currentRow.value?.is_month_leave,
    cwhd_idx: currentRow.value?.cwhd_idx,
    cwhd_taxable: currentRow.value?.cwhd_taxable,
  },
});

const calcResult = computed((): CommonWageCalcResult => {
  if (!props.taxRateInfo) return fallbackCalc.value;
  return computeCommonWageDetailForDisplay(buildCalcInput());
});

function computeFreshCalc(): CommonWageCalcResult {
  if (!props.taxRateInfo) return fallbackCalc.value;
  return computeCommonWageDetailForDisplay(buildCalcInput());
}

function computeFreshCalcForSave(): CommonWageCalcResult {
  if (!props.taxRateInfo) return fallbackCalc.value;
  return computeCommonWageDetailForSave(buildCalcInput());
}

function mergeDisplayCalc(base: CommonWageCalcResult): CommonWageCalcResult {
  return applyWageAmountOverrides(
    base,
    calcAmountOverrides.value,
    manualFlags.value,
    formStringsToNumbers(form.value),
    settings.value.cwhd_production_nontax
  );
}

const displayCalc = computed(() => {
  if (props.autoCalcMode) {
    return mergeDisplayCalc(calcResult.value);
  }
  const base =
    payrollDbLock.value && payrollCalcConfirmed.value ? dbCalcSnapshot.value : calcResult.value;
  let merged = mergeDisplayCalc(base);
  // DB 잠금 스냅샷의 과세가 회계(중식 채움) 기준이어도, 화면 과세·합계는 입력 중식 기준으로 맞춤
  // (비과세액 합계 = 입력 중식·차량·양육과 일치). 공제·실수령은 회계 기준 유지.
  if (settings.value.cwhd_lunch_expense && props.taxRateInfo) {
    const facility = computeCommonWageDetail(buildCalcInput());
    merged = {
      ...merged,
      cwhd_basic: facility.cwhd_basic,
      cwhd_overtime: facility.cwhd_overtime,
      cwhd_night: facility.cwhd_night,
      cwhd_holiday: facility.cwhd_holiday,
      cwhd_overtime_nontax: facility.cwhd_overtime_nontax,
      cwhd_night_nontax: facility.cwhd_night_nontax,
      cwhd_holiday_nontax: facility.cwhd_holiday_nontax,
      overtimeTotal: facility.overtimeTotal,
      nightTotal: facility.nightTotal,
      holidayTotal: facility.holidayTotal,
      cwhd_wage_total: facility.cwhd_wage_total,
      cwhd_taxable: facility.cwhd_taxable,
      cwhd_usual: facility.cwhd_usual,
      cwhd_lunch: formStringsToNumbers(form.value).cwhd_lunch,
      netPay: Math.max(0, facility.cwhd_wage_total - (Number(merged.cwhd_l_total) || 0)),
    };
  }
  return merged;
});

const unlockPayrollLedgerForEdit = () => {
  payrollDbLock.value = false;
};

function clearWageAmountOverride(calcKey: string) {
  if (!(calcKey in calcAmountOverrides.value)) return;
  const next = { ...calcAmountOverrides.value };
  delete next[calcKey];
  calcAmountOverrides.value = next;
}

function resolveCalcForSave(): CommonWageCalcResult {
  const base = props.autoCalcMode
    ? (autoCalcSnapshot.value ?? computeFreshCalcForSave())
    : (() => {
        // 잠금 스냅샷이 표시용(채움)일 수 있어 저장은 항상 지급칸 원본+회계공제로 재산출
        return computeFreshCalcForSave();
      })();
  const merged = mergeDisplayCalc(base);
  
  // 수동 입력된 공제값을 calc에 병합 (manualFlags가 true인 필드만)
  const f = manualFlags.value;
  const df = deductForm.value;
  if (f.yeon) { merged.cwhd_l_yeon = df.cwhd_l_yeon; merged.cwhd_c_yeon = df.cwhd_c_yeon; }
  if (f.gun) { merged.cwhd_l_gun = df.cwhd_l_gun; merged.cwhd_c_gun = df.cwhd_c_gun; }
  if (f.jang) { merged.cwhd_l_jang = df.cwhd_l_jang; merged.cwhd_c_jang = df.cwhd_c_jang; }
  if (f.l_go) merged.cwhd_l_go = df.cwhd_l_go;
  if (f.c_go) merged.cwhd_c_go = df.cwhd_c_go;
  if (f.l_so) merged.cwhd_l_so = df.cwhd_l_so;
  if (f.l_ji) merged.cwhd_l_ji = df.cwhd_l_ji;
  if (f.l_jiwon) merged.cwhd_l_jiwon = df.cwhd_l_jiwon;
  if (f.l_sik) merged.cwhd_l_sik = df.cwhd_l_sik;
  // 수동입력 전용 (자동계산 없음 → 항상 deductForm 값 사용)
  merged.cwhd_l_etc = df.cwhd_l_etc || 0;
  merged.cwhd_l_yearend = df.cwhd_l_yearend || 0;
  if (f.c_sil) merged.cwhd_c_sil = df.cwhd_c_sil;
  if (f.c_san) merged.cwhd_c_san = df.cwhd_c_san;
  if (f.c_out) merged.cwhd_c_out = df.cwhd_c_out;
  
  // 합계 재계산
  merged.cwhd_l_total = merged.cwhd_l_yeon + merged.cwhd_l_gun + merged.cwhd_l_jang + merged.cwhd_l_go
    + merged.cwhd_l_so + merged.cwhd_l_ji + merged.cwhd_l_jiwon + merged.cwhd_l_sik + merged.cwhd_l_etc + merged.cwhd_l_yearend;
  merged.cwhd_c_total = merged.cwhd_c_yeon + merged.cwhd_c_gun + merged.cwhd_c_jang + merged.cwhd_c_go
    + merged.cwhd_c_sil + merged.cwhd_c_san + merged.cwhd_c_out;
  
  return merged;
}

function getManualFlagForDeductKey(key: string): keyof CommonWageManualFlags | null {
  const pair = COMMON_WAGE_INSURANCE_SHARED.find((p) => p.laborKey === key || p.corpKey === key);
  if (pair) return pair.key as keyof CommonWageManualFlags;
  const map: Record<string, keyof CommonWageManualFlags> = {
    cwhd_l_go: 'l_go',
    cwhd_c_go: 'c_go',
    cwhd_l_so: 'l_so',
    cwhd_l_ji: 'l_ji',
    cwhd_l_jiwon: 'l_jiwon',
    cwhd_l_sik: 'l_sik',
    cwhd_l_etc: 'l_etc',
    cwhd_l_yearend: 'l_yearend',
    cwhd_c_sil: 'c_sil',
    cwhd_c_san: 'c_san',
    cwhd_c_out: 'c_out',
  };
  return map[key] ?? null;
}

function ensureDeductManual(key: string) {
  const flag = getManualFlagForDeductKey(key);
  if (!flag || manualFlags.value[flag]) return;
  const autoVal = Number((displayCalc.value as unknown as Record<string, number>)[key]) || 0;
  (deductForm.value as Record<string, number>)[key] = autoVal;
  const pair = COMMON_WAGE_INSURANCE_SHARED.find((p) => p.laborKey === key || p.corpKey === key);
  if (pair) {
    (deductForm.value as Record<string, number>)[pair.laborKey] = autoVal;
    (deductForm.value as Record<string, number>)[pair.corpKey] = autoVal;
  }
  manualFlags.value = { ...manualFlags.value, [flag]: true };
}

function onCalcAmountInput(key: string, rawValue?: string) {
  if (key === 'cwhd_basic' && basicCalcMode.value === 'basic') {
    const raw = String(rawValue ?? '').replace(/[^\d]/g, '');
    const num = raw ? parseInt(raw, 10) : 0;
    calcAmountOverrides.value = { ...calcAmountOverrides.value, [key]: num };
    manualFlags.value = { ...manualFlags.value, w_basic: true };
    syncWorkHoursFromBasic();
    syncDeductFormFromCalc();
    notifyChange();
    return;
  }
  if (WAGE_HOURS_DERIVED_CALC_KEYS.has(key)) return;
  const raw = String(rawValue ?? '').replace(/[^\d]/g, '');
  const num = raw ? parseInt(raw, 10) : 0;
  const flag = WAGE_AMOUNT_MANUAL_FLAG_BY_CALC_KEY[key];
  if (!flag) return;
  calcAmountOverrides.value = { ...calcAmountOverrides.value, [key]: num };
  manualFlags.value = { ...manualFlags.value, [flag]: true };
  syncDeductFormFromCalc();
  notifyChange();
}

function onCalcAmountBlur(key: string, event: Event) {
  if (key === 'cwhd_basic' && basicCalcMode.value === 'basic') {
    const num = parseWageNumber((event.target as HTMLInputElement).value);
    calcAmountOverrides.value = { ...calcAmountOverrides.value, [key]: num };
    manualFlags.value = { ...manualFlags.value, w_basic: true };
    (event.target as HTMLInputElement).value = num ? formatWageNumber(num) : '';
    syncWorkHoursFromBasic();
    syncDeductFormFromCalc();
    return;
  }
  if (WAGE_HOURS_DERIVED_CALC_KEYS.has(key)) return;
  const num = parseWageNumber((event.target as HTMLInputElement).value);
  const flag = WAGE_AMOUNT_MANUAL_FLAG_BY_CALC_KEY[key];
  if (!flag) return;
  calcAmountOverrides.value = { ...calcAmountOverrides.value, [key]: num };
  manualFlags.value = { ...manualFlags.value, [flag]: true };
  (event.target as HTMLInputElement).value = num ? formatWageNumber(num) : '';
  syncDeductFormFromCalc();
}

/** 기본급→시간 모드: 기본급·시급으로 근무시간 역산 */
function syncWorkHoursFromBasic() {
  if (basicCalcMode.value !== 'basic') return;
  const basic = Number(calcAmountOverrides.value.cwhd_basic) || 0;
  const hourly = parseWageNumber(form.value.cwhd_pay_calc_hourly);
  if (basic > 0 && hourly > 0) {
    const hours = Math.round((basic / hourly) * 10) / 10;
    form.value.cwhd_work_hours = formatHoursDisplay(hours);
  }
}

/** 자동계산 전 — 시급 미입력 시 DB 스냅샷/기본급으로 역산 (OFF→ON 시 기본급 0 방지) */
function ensureFormForAutoCalc() {
  const parsed = formStringsToNumbers(form.value);
  if (parsed.cwhd_pay_calc_hourly > 0) return;

  const hours = parsed.cwhd_work_hours;
  const snapBasic = Number(dbCalcSnapshot.value.cwhd_basic) || 0;
  if (snapBasic > 0 && hours > 0) {
    form.value.cwhd_pay_calc_hourly = formatWageNumber(Math.round(snapBasic / hours));
    return;
  }

  const rowBasic = Number(currentRow.value?.cwhd_basic) || 0;
  if (rowBasic > 0 && hours > 0) {
    form.value.cwhd_pay_calc_hourly = formatWageNumber(Math.round(rowBasic / hours));
    return;
  }

  // 근무시간이 입력된 경우에만 최저시급 제안 (미입력 상태에서 UI 기본값 주입 방지)
  if (hours > 0 && props.minHourlyWage) {
    form.value.cwhd_pay_calc_hourly = formatWageNumber(props.minHourlyWage);
  }
}

/** 자동계산 모드 — 입력·설정 변경 시 공제 연동 재계산 */
function applyAutoCalc() {
  if (!props.autoCalcMode || !props.taxRateInfo || autoCalcSyncing.value) return;
  autoCalcSyncing.value = true;
  skipCalcConfirmReset.value = true;
  try {
    unlockPayrollLedgerForEdit();
    ensureFormForAutoCalc();
    ensureWorkDaysInForm();
    if (basicCalcMode.value === 'basic') {
      syncWorkHoursFromBasic();
    }
    const pass1 = computeFreshCalc();
    syncDeductFormFromAuto(pass1);
    const freshDisplay = computeFreshCalc();
    const freshSave = computeFreshCalcForSave();
    autoCalcSnapshot.value = { ...freshSave };
    payrollCalcConfirmed.value = Number(freshDisplay.cwhd_wage_total) > 0;
  } finally {
    autoCalcSyncing.value = false;
    void nextTick(() => {
      skipCalcConfirmReset.value = false;
    });
  }
}

function formWorkDaysNumber(): number {
  return parseInt(String(form.value.cwhd_work_days).replace(/[^\d]/g, ''), 10) || 0;
}

function markAutoWorkDaysFromForm(row: CommonWageListRow | null) {
  if (row && Number(row.cwhd_work_days) > 0) {
    autoFilledWorkDays.value = null;
    return;
  }
  const current = formWorkDaysNumber();
  autoFilledWorkDays.value = current > 0 ? current : null;
}

/** 저장된 근무일수가 없고 사용자가 아직 고치지 않았으면 달력 영업일을 넣는다 */
function applyCalendarWorkDaysDefault() {
  if (workDaysTouched.value) return;
  const fallback = Number(props.defaultWorkDays);
  if (!Number.isFinite(fallback) || fallback <= 0) return;
  const row = currentRow.value;
  if (row && Number(row.cwhd_work_days) > 0) return;
  const next = Math.floor(fallback);
  const current = formWorkDaysNumber();
  if (current > 0 && current !== autoFilledWorkDays.value) return;
  if (current === next) {
    autoFilledWorkDays.value = next;
    return;
  }
  const wasSuppress = suppressChangeNotify.value;
  suppressChangeNotify.value = true;
  skipCalcConfirmReset.value = true;
  form.value.cwhd_work_days = String(next);
  autoFilledWorkDays.value = next;
  void nextTick(() => {
    suppressChangeNotify.value = wasSuppress;
    skipCalcConfirmReset.value = false;
  });
}

/** 근무일수 미입력(0)이면 달력 영업일, 없으면 근무시간÷8 — 계산·저장 시 임금대장 일수 반영 */
function ensureWorkDaysInForm() {
  const days = formWorkDaysNumber();
  if (days > 0) return;
  const fallback = Number(props.defaultWorkDays);
  if (Number.isFinite(fallback) && fallback > 0) {
    form.value.cwhd_work_days = String(Math.floor(fallback));
    autoFilledWorkDays.value = Math.floor(fallback);
    return;
  }
  if (props.defaultWorkDays === null) return;
  const hours = parseHours(form.value.cwhd_work_hours);
  if (hours <= 0) return;
  const inferred = inferWorkDaysFromHours(hours);
  if (inferred != null) {
    form.value.cwhd_work_days = String(inferred);
    autoFilledWorkDays.value = inferred;
  }
}

const runWageCalc = () => {
  if (props.autoCalcMode) {
    applyAutoCalc();
    return;
  }
  if (saving.value || deleting.value) return;
  if (!props.taxRateInfo) {
    alert('세율 정보를 불러오지 못했습니다.');
    return;
  }
  calculating.value = true;
  skipCalcConfirmReset.value = true;
  try {
    unlockPayrollLedgerForEdit();
    ensureWorkDaysInForm();
    if (basicCalcMode.value === 'basic') {
      syncWorkHoursFromBasic();
    }
    // 1차: 임금·과세 기준 자동 공제 산출 → 2차: 비수동 공제 필드 반영 후 최종 계산
    syncDeductFormFromAuto(computeFreshCalc());
    const fresh = computeFreshCalcForSave();
    dbCalcSnapshot.value = { ...fresh };
    payrollDbLock.value = true;
    payrollCalcConfirmed.value = Number(fresh.cwhd_wage_total) > 0;
    if (!payrollCalcConfirmed.value) {
      alert('시급·근무시간 등 근무정보를 입력해 주세요.');
    }
  } finally {
    calculating.value = false;
    void nextTick(() => {
      skipCalcConfirmReset.value = false;
    });
  }
};

const runDeductCalc = () => {
  runWageCalc();
};

const applyPrevMonthRow = (prev: CommonWageListRow) => {
  skipCalcConfirmReset.value = true;
  calcAmountOverrides.value = {};
  workDaysTouched.value = false;
  form.value = rowToFormStrings(prev, props.minHourlyWage, {
    skipWorkHoursDefault: true,
    defaultWorkDays: props.defaultWorkDays ?? null,
  });
  markAutoWorkDaysFromForm(prev);
  settings.value = rowToSettings(prev);
  applyDefaultProductionNontax(currentRow.value?.ce_position);
  manualFlags.value = stripHoursDerivedManualFlags(parseManualFlagsFromRow(prev.cwhd_manual_flags));
  deductForm.value = rowToDeductNumbers(prev);
  // 전월 합계는 당월 세율·간이세액표와 다를 수 있음 — 재계산 전에는 DB 스냅샷 잠금 해제
  dbCalcSnapshot.value = emptyCalc();
  payrollDbLock.value = false;
  payrollCalcConfirmed.value = false;
  void nextTick(() => {
    skipCalcConfirmReset.value = false;
  });
  notifyChange();
};

const importPrevMonthData = async () => {
  const row = currentRow.value;
  if (!row || !props.mCode) return false;
  try {
    const res = await commonWageApi.getPrevMonthWage({
      mCode: props.mCode,
      year: props.year,
      month: props.month,
      bizGubun: props.bizGubun,
      name: row.cwhd_name || row.ce_name || '',
      birth: resolveAuthoritativeBirth(row) || '',
    });
    if (!res.data?.success || !res.data.data) {
      alert('전월 급여 데이터가 없습니다.');
      return false;
    }
    applyPrevMonthRow(res.data.data as CommonWageListRow);
    validateLunchInput();
    await nextTick();
    applyAutoCalc();
    alert('지난달 근무·설정을 반영하고 당월 기준으로 자동 재계산했습니다.\n「저장」 버튼으로 저장하세요.');
    return true;
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`전월 데이터 가져오기 실패: ${message}`);
    return false;
  }
};

__expose({ importPrevMonthData, runWageCalc, runDeductCalc, saveWage: onSave, deleteWage: onDelete });

const ageInsurance = computed(() =>
  validateAgeInsurance(employeeBirthDate.value, props.year, props.month)
);

const productionWorkerValidation = computed(() => {
  const usualBeforeNontax = calcResult.value.cwhd_usual;
  return validateProductionWorkerNontax(currentRow.value?.ce_position, usualBeforeNontax);
});

/** 방문요양과 동일 — 대상 직종이면 생산직 비과세 기본 ON (통상 한도 초과는 watch가 해제) */
function applyDefaultProductionNontax(position?: string | null) {
  if (isProductionWorkerPosition(position)) {
    settings.value.cwhd_production_nontax = true;
  }
}

watch(
  () => settings.value.cwhd_lunch_expense,
  () => {
    validateLunchInput();
    if (props.autoCalcMode) applyAutoCalc();
    else syncDeductFormFromCalc();
  }
);

watch(
  () => productionWorkerValidation.value.canApply,
  (canApply) => {
    if (!canApply && settings.value.cwhd_production_nontax) {
      settings.value.cwhd_production_nontax = false;
    }
  }
);

function syncDeductFormFromAuto(calc: CommonWageCalcResult) {
  const auto = calcToDeductNumbers(calc);
  const f = manualFlags.value;
  // 3대보험 (근로·기관 동일)
  if (!f.yeon) {
    deductForm.value.cwhd_l_yeon = auto.cwhd_l_yeon;
    deductForm.value.cwhd_c_yeon = auto.cwhd_c_yeon;
  }
  if (!f.gun) {
    deductForm.value.cwhd_l_gun = auto.cwhd_l_gun;
    deductForm.value.cwhd_c_gun = auto.cwhd_c_gun;
  }
  if (!f.jang) {
    deductForm.value.cwhd_l_jang = auto.cwhd_l_jang;
    deductForm.value.cwhd_c_jang = auto.cwhd_c_jang;
  }
  // 고용보험 (근로·기관 분리)
  if (!f.l_go) deductForm.value.cwhd_l_go = auto.cwhd_l_go;
  if (!f.c_go) deductForm.value.cwhd_c_go = auto.cwhd_c_go;
  // 근로자 기타 공제
  if (!f.l_so) deductForm.value.cwhd_l_so = auto.cwhd_l_so;
  if (!f.l_ji) deductForm.value.cwhd_l_ji = auto.cwhd_l_ji;
  if (!f.l_jiwon) deductForm.value.cwhd_l_jiwon = auto.cwhd_l_jiwon;
  if (!f.l_sik) deductForm.value.cwhd_l_sik = auto.cwhd_l_sik;
  // l_etc, l_yearend — 수동입력 전용, 자동 덮어쓰기 금지
  // 기관 기타 공제
  if (!f.c_sil) deductForm.value.cwhd_c_sil = auto.cwhd_c_sil;
  if (!f.c_san) deductForm.value.cwhd_c_san = auto.cwhd_c_san;
  if (!f.c_out) deductForm.value.cwhd_c_out = auto.cwhd_c_out;
}

function syncDeductFormFromCalc() {
  if (props.autoCalcMode) {
    applyAutoCalc();
    return;
  }
  syncDeductFormFromAuto(displayCalc.value);
}

function clearWageOverrideForManualFlag(field: keyof CommonWageManualFlags) {
  const calcKey = Object.entries(WAGE_AMOUNT_MANUAL_FLAG_BY_CALC_KEY).find(([, f]) => f === field)?.[0];
  if (calcKey) clearWageAmountOverride(calcKey);
}

const MANUAL_FLAG_TO_DEDUCT_KEYS: Record<string, string[]> = {
  yeon: ['cwhd_l_yeon', 'cwhd_c_yeon'],
  gun: ['cwhd_l_gun', 'cwhd_c_gun'],
  jang: ['cwhd_l_jang', 'cwhd_c_jang'],
  l_go: ['cwhd_l_go'],
  c_go: ['cwhd_c_go'],
  l_so: ['cwhd_l_so'],
  l_ji: ['cwhd_l_ji'],
  l_jiwon: ['cwhd_l_jiwon'],
  l_sik: ['cwhd_l_sik'],
  l_etc: ['cwhd_l_etc'],
  l_yearend: ['cwhd_l_yearend'],
  c_sil: ['cwhd_c_sil'],
  c_san: ['cwhd_c_san'],
  c_out: ['cwhd_c_out'],
};

function copyAutoValueToDeductForm(field: keyof CommonWageManualFlags) {
  const keys = MANUAL_FLAG_TO_DEDUCT_KEYS[field];
  if (!keys) return;
  for (const key of keys) {
    const autoVal = Number((displayCalc.value as unknown as Record<string, number>)[key]) || 0;
    (deductForm.value as Record<string, number>)[key] = autoVal;
  }
}

const MANUAL_FLAG_LABELS: Record<string, string> = {
  yeon: '국민연금',
  gun: '건강보험',
  jang: '장기요양',
  l_go: '고용보험(근로)',
  c_go: '고용보험(기관)',
  l_so: '소득세',
  l_ji: '지방세',
  l_jiwon: '지원공제',
  l_sik: '중식비공제',
  l_etc: '기타공제',
  l_yearend: '연말정산',
  c_sil: '실업급여',
  c_san: '산재보험',
  c_out: '퇴직금',
  w_basic: '기본급',
  w_overtime: '연장수당',
  w_night: '야간수당',
  w_holiday: '휴일수당',
  w_ot_nontax: '연장(비과세)',
  w_n_ntax: '야간(비과세)',
  w_h_ntax: '휴일(비과세)',
};

function onManualFlagChange(field: keyof CommonWageManualFlags, event: Event) {
  if (saving.value || deleting.value) return;
  const checked = (event.target as HTMLInputElement).checked;
  if (MANUAL_FLAG_TO_DEDUCT_KEYS[field]) {
    onToggleManual(field, checked);
    return;
  }
  if (!checked) {
    clearWageOverrideForManualFlag(field);
  }
  manualFlags.value = { ...manualFlags.value, [field]: checked };
  syncDeductFormFromCalc();
  notifyChange();
}

function onToggleManual(field: keyof CommonWageManualFlags | string, checked: boolean) {
  const key = field as keyof CommonWageManualFlags;
  if (!checked) {
    clearWageOverrideForManualFlag(key);
    manualFlags.value = { ...manualFlags.value, [key]: false };
    syncDeductFormFromCalc();
    notifyChange();
    return;
  }
  copyAutoValueToDeductForm(key);
  manualFlags.value = { ...manualFlags.value, [key]: true };
  syncDeductFormFromCalc();
  notifyChange();
  openDeductionFixModal(key, true);
}

const showDeductionFixModal = ref(false);
const deductionFixModalTarget = ref<keyof CommonWageManualFlags | null>(null);
const deductionFixModalManualDisplay = ref('');
/** 체크해서 연 창을 취소하면 체크를 되돌린다 */
const deductionFixOpenedFromCheck = ref(false);

const deductionFixModalPreview = computed(() => {
  if (!deductionFixModalTarget.value || !props.taxRateInfo) {
    return { hasAuto: false, applied: 0, nominal: 0, formula: '', notes: undefined as string | undefined };
  }
  return previewCommonWageDeductionFix(buildCalcInput(), deductionFixModalTarget.value);
});

const deductionFixAmountsDiffer = computed(
  () =>
    deductionFixModalPreview.value.hasAuto &&
    deductionFixModalPreview.value.applied !== deductionFixModalPreview.value.nominal
);

const deductionFixAutoLabel = computed(() =>
  deductionFixAmountsDiffer.value ? '요율 기준 산출액' : '자동계산 금액'
);

const deductionFixAutoButtonLabel = computed(() =>
  deductionFixAmountsDiffer.value ? '요율 기준 금액 사용' : '자동계산 금액 사용'
);

const deductionFixAutoHint = computed(() =>
  deductionFixAmountsDiffer.value
    ? '면제 조건을 적용하지 않고, 정해진 요율만으로 계산한 금액입니다.'
    : ''
);

const deductionFixAppliedAmount = computed(() =>
  deductionFixAmountsDiffer.value ? deductionFixModalPreview.value.applied : null
);

const deductionFixModalTitle = computed(() => {
  const key = deductionFixModalTarget.value;
  if (!key) return '금액 설정';
  return `${MANUAL_FLAG_LABELS[key] || '공제'} 금액 설정`;
});

const deductionFixModalCurrentAmount = computed(() => {
  const key = deductionFixModalTarget.value;
  if (!key) return 0;
  const deductKey = MANUAL_FLAG_TO_DEDUCT_KEYS[key]?.[0];
  if (!deductKey) return 0;
  return Number((deductForm.value as Record<string, number>)[deductKey]) || 0;
});

const deductionFixModalHasCurrent = computed(
  () =>
    !!deductionFixModalTarget.value &&
    !!manualFlags.value[deductionFixModalTarget.value] &&
    deductionFixModalCurrentAmount.value !== deductionFixModalPreview.value.nominal &&
    deductionFixModalCurrentAmount.value !== deductionFixModalPreview.value.applied
);

function openDeductionFixModal(field: keyof CommonWageManualFlags, fromCheck = false) {
  if (!MANUAL_FLAG_TO_DEDUCT_KEYS[field]) return;
  deductionFixOpenedFromCheck.value = fromCheck;
  deductionFixModalTarget.value = field;
  const deductKey = MANUAL_FLAG_TO_DEDUCT_KEYS[field][0];
  const current = Number((deductForm.value as Record<string, number>)[deductKey]) || 0;
  deductionFixModalManualDisplay.value = current ? formatWageNumber(current) : '';
  showDeductionFixModal.value = true;
}

function closeDeductionFixModal() {
  showDeductionFixModal.value = false;
  deductionFixModalTarget.value = null;
  deductionFixModalManualDisplay.value = '';
  deductionFixOpenedFromCheck.value = false;
}

function cancelDeductionFixModal() {
  const field = deductionFixModalTarget.value;
  const revert = deductionFixOpenedFromCheck.value;
  closeDeductionFixModal();
  if (!revert || !field) return;
  manualFlags.value = { ...manualFlags.value, [field]: false };
  syncDeductFormFromCalc();
  notifyChange();
}

function applyDeductionFixAmount(amount: number) {
  const field = deductionFixModalTarget.value;
  if (!field) return;
  const keys = MANUAL_FLAG_TO_DEDUCT_KEYS[field] || [];
  for (const key of keys) {
    (deductForm.value as Record<string, number>)[key] = Math.max(0, Math.floor(amount));
  }
  manualFlags.value = { ...manualFlags.value, [field]: true };
  syncDeductFormFromCalc();
  notifyChange();
  closeDeductionFixModal();
}

function applyDeductionFixModalNominal() {
  applyDeductionFixAmount(deductionFixModalPreview.value.nominal);
}

function applyDeductionFixModalApplied() {
  applyDeductionFixAmount(deductionFixModalPreview.value.applied);
}

function applyDeductionFixModalManual() {
  applyDeductionFixAmount(parseWageNumber(deductionFixModalManualDisplay.value));
}

function onDeductionFixModalManualInput(event: Event) {
  const raw = (event.target as HTMLInputElement).value.replace(/[^\d]/g, '');
  deductionFixModalManualDisplay.value = raw ? formatWageNumber(Number(raw)) : '';
}

function onDeductInput(key: string, event: Event) {
  ensureDeductManual(key);
  const raw = (event.target as HTMLInputElement).value.replace(/[^\d]/g, '');
  const num = raw ? parseInt(raw, 10) : 0;
  (deductForm.value as Record<string, number>)[key] = num;
  const pair = COMMON_WAGE_INSURANCE_SHARED.find((p) => p.laborKey === key);
  if (pair) {
    (deductForm.value as Record<string, number>)[pair.corpKey] = num;
  }
  syncDeductFormFromCalc();
  notifyChange();
}

function onDeductBlur(key: string, event: Event) {
  // ensureDeductManual은 onDeductInput에서 이미 호출됨 — blur에서는 제거
  // (인풋에 포커스만 했다가 빠져나가도 체크박스가 체크되는 문제 방지)
  const num = parseWageNumber((event.target as HTMLInputElement).value);
  // 수동입력 플래그가 설정된 경우에만 값 저장
  const flag = getManualFlagForDeductKey(key);
  if (flag && manualFlags.value[flag]) {
    (deductForm.value as Record<string, number>)[key] = num;
    const pair = COMMON_WAGE_INSURANCE_SHARED.find((p) => p.laborKey === key);
    if (pair) {
      (deductForm.value as Record<string, number>)[pair.corpKey] = num;
    }
  }
  (event.target as HTMLInputElement).value = num ? formatWageNumber(num) : '';
  syncDeductFormFromCalc();
}

function validateLunchInput() {
  const lunch = parseWageNumber(form.value.cwhd_lunch);
  lunchValidation.value = validateLunchExpense(
    lunch,
    prevMonthLunch.value,
    settings.value.cwhd_lunch_expense
  );
}

async function loadPrevLunch(row: CommonWageListRow) {
  if (!props.mCode) return;
  try {
    const res = await commonWageApi.getPrevLunch({
      mCode: props.mCode,
      name: row.cwhd_name || row.ce_name || '',
      birth: resolveAuthoritativeBirth(row),
      year: props.year,
      month: props.month,
    });
    prevMonthLunch.value =
      res.data?.success && res.data.data?.prevLunch != null
        ? Number(res.data.data.prevLunch)
        : null;
  } catch {
    prevMonthLunch.value = null;
  }
  validateLunchInput();
}

async function loadIncomeTax() {
  incomeTaxTable.value = [];
  incomeTaxYearNote.value = '';
  try {
    const res = await commonWageApi.getIncomeTax(props.year);
    if (res.data?.success && Array.isArray(res.data.data)) {
      incomeTaxTable.value = res.data.data.map((row: any) => ({
        income1: Number(row.income1),
        income2: Number(row.income2),
        depe_1: Number(row.depe_1),
      }));
      if (res.data.isFallback && res.data.actualYear) {
        incomeTaxYearNote.value = `${res.data.actualYear}년 간이세액표 적용`;
      }
    }
  } catch (error: any) {
    console.error('간이세액표 로드 오류:', error);
  }
}

async function completeFormHydration() {
  if (props.autoCalcMode) {
    applyAutoCalc();
  }
  await nextTick();
  skipCalcConfirmReset.value = false;
  suppressChangeNotify.value = false;
  emit('hydrated');
}

function resolveBasicCalcMode(row: CommonWageListRow): 'hourly' | 'basic' {
  if (!props.basicCalcModeAllowed) return 'hourly';
  if (row.cwhd_basic_calc_mode === 'basic' || row.cwhd_basic_calc_mode === 'hourly') {
    return row.cwhd_basic_calc_mode;
  }
  return 'basic';
}

function loadFormFromRow(row: CommonWageListRow) {
  suppressChangeNotify.value = true;
  skipCalcConfirmReset.value = true;
  autoCalcSnapshot.value = null;
  calcAmountOverrides.value = {};
  workDaysTouched.value = false;
  form.value = rowToFormStrings(row, props.minHourlyWage, {
    ...getRowToFormDefaultOptions(row),
    defaultWorkDays: props.defaultWorkDays ?? null,
  });
  markAutoWorkDaysFromForm(row);
  manualFlags.value = stripHoursDerivedManualFlags(parseManualFlagsFromRow(row.cwhd_manual_flags));
  // 관리자이고 DB에 산출 방식이 없으면 기본급→시간. 저장된 값이 있으면 그 값.
  basicCalcMode.value = resolveBasicCalcMode(row);
  if (basicCalcMode.value === 'basic' && row.cwhd_idx) {
    // 기본급→시간 모드: 저장된 기본급을 수동값으로 고정해야 표시값이 DB와 일치
    const savedBasic = Number(row.cwhd_basic) || 0;
    if (savedBasic > 0) {
      calcAmountOverrides.value = { cwhd_basic: savedBasic };
      manualFlags.value = { ...manualFlags.value, w_basic: true };
    }
  }

  if (row.cwhd_idx) {
    settings.value = rowToSettings(row);
    applyDefaultProductionNontax(row.ce_position);
    deductForm.value = rowToDeductNumbers(row);
    dbCalcSnapshot.value = rowToCalcSnapshot(row);
    payrollDbLock.value = true;
    payrollCalcConfirmed.value = Number(row.cwhd_wage_total) > 0;
  } else {
    settings.value = {
      cwhd_production_nontax: defaultProductionNontax(row.ce_position),
      cwhd_lunch_expense: false,
      cwhd_is_owner: false,
    };
    deductForm.value = emptyDeductNumbers();
    manualFlags.value = {};
    dbCalcSnapshot.value = emptyCalc();
    payrollDbLock.value = false;
    payrollCalcConfirmed.value = false;
  }

  void loadPrevLunch(row);
}

async function hydrateFormFromRow(row: CommonWageListRow) {
  loadFormFromRow(row);
  await loadIncomeTax();
  await completeFormHydration();
}

watch(
  [form, settings, manualFlags],
  () => {
    if (skipCalcConfirmReset.value) return;
    if (props.autoCalcMode) {
      applyAutoCalc();
      return;
    }
    if (payrollCalcConfirmed.value) {
      payrollCalcConfirmed.value = false;
    }
  },
  { deep: true }
);

watch(
  () => props.autoCalcMode,
  (enabled) => {
    if (!isPanelActive.value) return;
    if (enabled) {
      applyAutoCalc();
      return;
    }
    autoCalcSnapshot.value = null;
    const fresh = computeFreshCalc();
    dbCalcSnapshot.value = { ...fresh };
    payrollDbLock.value = true;
    payrollCalcConfirmed.value = Number(fresh.cwhd_wage_total) > 0;
  }
);

watch(incomeTaxTable, () => {
  if (props.autoCalcMode && isPanelActive.value) {
    applyAutoCalc();
  }
});

watch(
  () => props.taxRateInfo,
  (info) => {
    if (props.autoCalcMode && info && isPanelActive.value) {
      applyAutoCalc();
    }
  }
);

watch(basicCalcMode, (mode) => {
  if (!isPanelActive.value || suppressChangeNotify.value) return;
  if (mode === 'basic') {
    // 기본급→시간 전환: 현재 표시 기본급을 수동값으로 고정하고 시간 역산
    const currentBasic = Number(displayCalc.value.cwhd_basic) || 0;
    if (currentBasic > 0) {
      calcAmountOverrides.value = { ...calcAmountOverrides.value, cwhd_basic: currentBasic };
      manualFlags.value = { ...manualFlags.value, w_basic: true };
      syncWorkHoursFromBasic();
    }
  } else {
    // 시급×시간 전환: 기본급 수동값 해제
    clearWageAmountOverride('cwhd_basic');
    const next = { ...manualFlags.value };
    delete next.w_basic;
    manualFlags.value = next;
  }
  if (props.autoCalcMode) {
    applyAutoCalc();
  }
});

watch(
  [form, settings, deductForm, manualFlags],
  () => {
    if (skipCalcConfirmReset.value) return;
    if (props.autoCalcMode) return;
    if (payrollCalcConfirmed.value) {
      payrollCalcConfirmed.value = false;
    }
  },
  { deep: true }
);

function onAmountInput(field: CcwdFormInputField, rawValue?: string) {
  const raw = String(rawValue ?? form.value[field] ?? '').replace(/[^\d]/g, '');
  let num = raw ? parseInt(raw, 10) : 0;
  if (field === 'cwhd_lunch' || field === 'cwhd_car' || field === 'cwhd_child') {
    num = clampNontaxCashFieldInput(field, num);
  }
  form.value[field] = num ? formatWageNumber(num) : '';
  if (field === 'cwhd_lunch') validateLunchInput();
  notifyChange();
}

function handleHoursInput(field: CcwdFormInputField, event: Event) {
  const target = event.target as HTMLInputElement;
  const cleaned = onHoursInput(field, target.value);
  if (cleaned !== target.value) {
    target.value = cleaned;
  }
}

function onHoursInput(field: CcwdFormInputField, rawValue?: string): string {
  if (field === 'cwhd_work_days') {
    let cleaned = String(rawValue ?? form.value[field] ?? '').replace(/[^\d]/g, '');
    const num = parseInt(cleaned, 10) || 0;
    if (num > 31) cleaned = '31';
    workDaysTouched.value = true;
    autoFilledWorkDays.value = null;
    form.value[field] = cleaned;
    notifyChange();
    return cleaned;
  }

  let cleaned = sanitizeHoursInput(String(rawValue ?? form.value[field] ?? ''));
  const num = parseHours(cleaned);
  if (num >= 1000) {
    cleaned = '999.9';
  }
  form.value[field] = cleaned;
  notifyChange();
  return cleaned;
}

function clearHoursDerivedAmountOverrides() {
  for (const key of WAGE_HOURS_DERIVED_CALC_KEYS) {
    if (key === 'cwhd_basic' && basicCalcMode.value === 'basic') continue;
    clearWageAmountOverride(key);
  }
  const stripped = stripHoursDerivedManualFlags(manualFlags.value);
  if (basicCalcMode.value === 'basic' && manualFlags.value.w_basic) {
    stripped.w_basic = true;
  }
  manualFlags.value = stripped;
}

const PREMIUM_HOURS_FORM_FIELDS: CcwdFormInputField[] = [
  'cwhd_overtime_hours',
  'cwhd_night_hours',
  'cwhd_holiday_hours',
];

function onHoursBlur(field: CcwdFormInputField) {
  const before = form.value[field];
  if (field === 'cwhd_work_days') {
    const num = parseInt(String(form.value.cwhd_work_days).replace(/[^\d]/g, ''), 10) || 0;
    form.value.cwhd_work_days = num > 0 ? String(num) : '';
    if (form.value[field] !== before) notifyChange();
    return;
  }
  form.value[field] = normalizeHoursInputValue(form.value[field]);
  if (
    field === 'cwhd_work_hours' ||
    PREMIUM_HOURS_FORM_FIELDS.includes(field)
  ) {
    clearHoursDerivedAmountOverrides();
  }
  if (form.value[field] !== before) notifyChange();
}

function onHourlyBlur() {
  const before = form.value.cwhd_pay_calc_hourly;
  clearHoursDerivedAmountOverrides();
  const hourly = parseWageNumber(form.value.cwhd_pay_calc_hourly);
  if (props.minHourlyWage && hourly > 0 && hourly < props.minHourlyWage) {
    alert(`시급은 최저시급(${formatWageNumber(props.minHourlyWage)}원) 이상이어야 합니다.`);
    form.value.cwhd_pay_calc_hourly = formatWageNumber(props.minHourlyWage);
  } else if (hourly > 0) {
    form.value.cwhd_pay_calc_hourly = formatWageNumber(hourly);
  } else {
    form.value.cwhd_pay_calc_hourly = '';
  }
  if (basicCalcMode.value === 'basic') {
    syncWorkHoursFromBasic();
  }
  if (form.value.cwhd_pay_calc_hourly !== before) notifyChange();
}

watch(
  () => [isPanelActive.value, props.row, props.year, props.month, props.bizGubun] as const,
  async ([visible, row, year, month, bizGubun], oldTuple) => {
    if (visible && row) {
      const ym = `${year}${String(month).padStart(2, '0')}`;

      const [oldVisible, oldRow, oldYear, oldMonth, oldBizGubun] = oldTuple ?? [false, null, 0, 0, ''];
      const newKey = rowEmpKey(row);
      const oldKey = oldRow ? rowEmpKey(oldRow) : null;

      const employeeChanged = newKey !== oldKey;
      const periodChanged = year !== oldYear || month !== oldMonth || bizGubun !== oldBizGubun;
      const panelJustOpened = visible && !oldVisible;
      /** API 응답으로 row만 갱신될 때(월 props는 이미 변경됨) form 재로드 */
      const rowYmChanged =
        !!oldRow &&
        String(oldRow.cwhd_ym || '') !== String(row.cwhd_ym || '') &&
        rowEmpKey(oldRow) === newKey;

      // 저장된 행이면 반드시 현재 선택 연월과 일치해야 함 (이전 월 row 잔존 방지)
      if (row.cwhd_idx && String(row.cwhd_ym || '') !== ym) {
        return;
      }

      currentRow.value = row;

      if (employeeChanged || periodChanged || panelJustOpened || rowYmChanged) {
        selectedEmpKey.value = newKey;
        await hydrateFormFromRow(row);
      }
    } else if (!visible) {
      currentRow.value = null;
      selectedEmpKey.value = null;
    }
  },
  { immediate: true }
);

watch(
  () => props.defaultWorkDays,
  () => {
    applyCalendarWorkDaysDefault();
  }
);

function onDialogUpdate(v: boolean) {
  if (!v) emit('close');
}

async function onSave() {
  const row = currentRow.value;
  if (!row || !props.mCode) return;

  const hourly = parseWageNumber(form.value.cwhd_pay_calc_hourly);
  if (props.minHourlyWage && hourly > 0 && hourly < props.minHourlyWage) {
    alert(`시급은 최저시급(${formatWageNumber(props.minHourlyWage)}원) 이상이어야 합니다.`);
    return;
  }

  validateLunchInput();
  if (lunchValidation.value && !lunchValidation.value.isValid) {
    alert(lunchValidation.value.message);
    return;
  }

  if (
    settings.value.cwhd_production_nontax &&
    !productionWorkerValidation.value.canApply
  ) {
    alert(
      productionWorkerValidation.value.usualMessage ||
        productionWorkerValidation.value.positionMessage ||
        '생산직근로자 비과세를 적용할 수 없습니다.'
    );
    return;
  }

  applyAutoCalc();

  ensureWorkDaysInForm();

  const calc = resolveCalcForSave();
  if (!Number(calc.cwhd_wage_total)) {
    alert('급여 합계가 0원입니다. 근무정보를 입력해 주세요.');
    return;
  }

  saving.value = true;
  try {
    const payload = buildSavePayload({
      meta: {
        m_code: props.mCode,
        cwhd_name: row.cwhd_name || row.ce_name || '',
        cwhd_birth: resolveAuthoritativeBirth(row),
        cwhd_ym: `${props.year}${String(props.month).padStart(2, '0')}`,
        cwhd_biz_gubun: props.bizGubun,
      },
      calc,
      form: form.value,
      settings: settings.value,
      manualFlags: manualFlags.value,
      basicCalcMode: basicCalcMode.value,
    });

    const res = await commonWageApi.save(payload);
    if (!res.data?.success) {
      throw new Error(res.data?.message || '저장 실패');
    }
    alert(res.data.message || '저장되었습니다.');
    emit('saved');
    if (!props.inline) emit('close');
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`임금 저장 실패: ${message}`);
  } finally {
    saving.value = false;
  }
}

async function onDelete() {
  const row = currentRow.value;
  if (!row?.cwhd_idx) return;
  if (!confirm(`${employeeName.value} 님의 ${props.year}년 ${props.month}월 임금 데이터를 삭제할까요?`)) {
    return;
  }

  deleting.value = true;
  try {
    const res = await commonWageApi.delete(row.cwhd_idx);
    if (!res.data?.success) throw new Error(res.data?.message || '삭제 실패');
    alert(res.data.message || '목록에서 제거되었습니다.');
    emit('deleted');
    if (!props.inline) {
      emit('close');
    }
  } catch (error: any) {
    alert(`삭제 실패: ${error.response?.data?.message || error.message}`);
  } finally {
    deleting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.inline ? 'div' : 'v-dialog'), _mergeProps(outerBind.value, { "onUpdate:modelValue": onDialogUpdate }), {
      default: _withCtx(() => [
        (__props.inline)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(LoadingOverlay, {
                show: saving.value,
                text: "저장 중...",
                variant: "save"
              }, null, 8, ["show"]),
              _createVNode(LoadingOverlay, {
                show: deleting.value,
                text: "삭제 중...",
                variant: "delete"
              }, null, 8, ["show"]),
              _createVNode(CommonWageDetailBoard, {
                form: form.value,
                "display-calc": displayCalc.value,
                "deduct-form": deductForm.value,
                "manual-flags": manualFlags.value,
                "production-nontax": settings.value.cwhd_production_nontax,
                "onUpdate:productionNontax": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.cwhd_production_nontax) = $event)),
                "lunch-expense": settings.value.cwhd_lunch_expense,
                "onUpdate:lunchExpense": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.cwhd_lunch_expense) = $event)),
                "is-owner": settings.value.cwhd_is_owner,
                "onUpdate:isOwner": _cache[2] || (_cache[2] = ($event: any) => ((settings.value.cwhd_is_owner) = $event)),
                "basic-calc-mode": basicCalcMode.value,
                "onUpdate:basicCalcMode": _cache[3] || (_cache[3] = ($event: any) => ((basicCalcMode).value = $event)),
                "basic-calc-mode-allowed": __props.basicCalcModeAllowed,
                "show-production-worker-option": showProductionWorkerOption.value,
                "production-nontax-allowed": productionWorkerValidation.value.canApply,
                "min-hourly-wage": __props.minHourlyWage,
                year: year.value,
                disabled: saving.value || deleting.value,
                "pension-exempt": ageInsurance.value.pensionExempt,
                "employment-exempt": ageInsurance.value.employmentExempt,
                "lunch-invalid": !!(lunchValidation.value && !lunchValidation.value.isValid),
                "lunch-warning": lunchValidation.value && !lunchValidation.value.isValid ? lunchValidation.value.message : '',
                onAmountInput: onAmountInput,
                onHoursInput: onHoursInput,
                onHoursBlur: onHoursBlur,
                onHourlyBlur: onHourlyBlur,
                onToggleManual: onToggleManual,
                onOpenManual: openDeductionFixModal,
                onDeductInput: onDeductInput,
                onDeductBlur: onDeductBlur,
                onCalcAmountInput: onCalcAmountInput,
                onCalcAmountBlur: onCalcAmountBlur
              }, null, 8, ["form", "display-calc", "deduct-form", "manual-flags", "production-nontax", "lunch-expense", "is-owner", "basic-calc-mode", "basic-calc-mode-allowed", "show-production-worker-option", "production-nontax-allowed", "min-hourly-wage", "year", "disabled", "pension-exempt", "employment-exempt", "lunch-invalid", "lunch-warning"])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (employeeOptions.value.length > 1)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedEmpKey).value = $event)),
                        class: "emp-select",
                        onChange: onEmployeeSelectChange
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeOptions.value, (emp) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: _unref(rowEmpKey)(emp),
                            value: _unref(rowEmpKey)(emp)
                          }, _toDisplayString(emp.ce_name) + " (" + _toDisplayString(emp.ce_position || '-') + ") ", 9, _hoisted_4))
                        }), 128))
                      ], 544)), [
                        [_vModelSelect, selectedEmpKey.value]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(employeeName.value), 1)),
                  (currentRow.value?.ce_join_date)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "입사 " + _toDisplayString(currentRow.value.ce_join_date), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "close-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('close')))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[85] || (_cache[85] = _createElementVNode("div", { class: "box-title" }, "설정", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    (showProductionWorkerOption.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            id: "cw-production-nontax",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((settings.value.cwhd_production_nontax) = $event)),
                            type: "checkbox",
                            disabled: !productionWorkerValidation.value.canApply && !settings.value.cwhd_production_nontax
                          }, null, 8, _hoisted_11), [
                            [_vModelCheckbox, settings.value.cwhd_production_nontax]
                          ]),
                          _cache[79] || (_cache[79] = _createElementVNode("label", {
                            for: "cw-production-nontax",
                            class: "check-text"
                          }, "생산직근로자 비과세 적용", -1)),
                          (!productionWorkerValidation.value.canApply)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "top"
                              }, {
                                activator: _withCtx(({ props: tipProps }) => [
                                  _createVNode(_component_v_icon, _mergeProps(tipProps, {
                                    size: "16",
                                    color: "warning",
                                    class: "setting-warning-icon"
                                  }), {
                                    default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                      _createTextVNode(" mdi-alert-circle ", -1)
                                    ]))]),
                                    _: 1
                                  }, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(productionWorkerValidation.value.usualMessage || productionWorkerValidation.value.positionMessage), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "cw-lunch-expense",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((settings.value.cwhd_lunch_expense) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, settings.value.cwhd_lunch_expense]
                      ]),
                      _cache[81] || (_cache[81] = _createElementVNode("label", {
                        for: "cw-lunch-expense",
                        class: "check-text"
                      }, "중식비 실비변상 처리", -1)),
                      (lunchValidation.value && !lunchValidation.value.isValid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "warning"
                            }, {
                              default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                                _createTextVNode("mdi-alert", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(lunchValidation.value.message), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        id: "cw-is-owner",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((settings.value.cwhd_is_owner) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, settings.value.cwhd_is_owner]
                      ]),
                      _cache[84] || (_cache[84] = _createElementVNode("label", {
                        for: "cw-is-owner",
                        class: "check-text"
                      }, "대표자", -1)),
                      _createVNode(_component_v_tooltip, { location: "top" }, {
                        activator: _withCtx(({ props: tipProps }) => [
                          _createVNode(_component_v_icon, _mergeProps(tipProps, {
                            size: "14",
                            color: "info",
                            class: "setting-info-icon"
                          }), {
                            default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                              _createTextVNode(" mdi-information-outline ", -1)
                            ]))]),
                            _: 1
                          }, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[83] || (_cache[83] = _createElementVNode("span", null, "대표자는 고용/실업/산재보험, 퇴직금이 면제됩니다", -1))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, [
                        _cache[86] || (_cache[86] = _createTextVNode(" 근로정보 ", -1)),
                        (__props.minHourlyWage)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " (" + _toDisplayString(year.value) + "년 최저 " + _toDisplayString(_unref(formatWageNumber)(__props.minHourlyWage)) + "원) ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (__props.basicCalcModeAllowed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["wage-basic-calc-mode__btn", { 'wage-basic-calc-mode__btn--active': basicCalcMode.value === 'hourly' }]),
                              disabled: saving.value || deleting.value,
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (basicCalcMode.value = 'hourly'))
                            }, "시급×시간", 10, _hoisted_20),
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["wage-basic-calc-mode__btn", { 'wage-basic-calc-mode__btn--active': basicCalcMode.value === 'basic' }]),
                              disabled: saving.value || deleting.value,
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (basicCalcMode.value = 'basic'))
                            }, "기본급→시간", 10, _hoisted_21)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("table", _hoisted_22, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_23, [
                            _cache[87] || (_cache[87] = _createElementVNode("label", null, "시급", -1)),
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(CommonWageHourlyInput, {
                                modelValue: form.value.cwhd_pay_calc_hourly,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.cwhd_pay_calc_hourly) = $event)),
                                "min-hourly-wage": __props.minHourlyWage,
                                disabled: saving.value || deleting.value
                              }, null, 8, ["modelValue", "min-hourly-wage", "disabled"])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _cache[88] || (_cache[88] = _createElementVNode("label", null, "일수", -1)),
                            _createElementVNode("input", {
                              value: form.value.cwhd_work_days,
                              type: "text",
                              onInput: _cache[12] || (_cache[12] = ($event: any) => (handleHoursInput('cwhd_work_days', $event))),
                              onBlur: _cache[13] || (_cache[13] = ($event: any) => (onHoursBlur('cwhd_work_days')))
                            }, null, 40, _hoisted_25)
                          ]),
                          _createElementVNode("td", null, [
                            _cache[89] || (_cache[89] = _createElementVNode("label", null, "시간", -1)),
                            _createElementVNode("input", {
                              value: form.value.cwhd_work_hours,
                              type: "text",
                              disabled: saving.value || deleting.value || basicCalcMode.value === 'basic',
                              onInput: _cache[14] || (_cache[14] = ($event: any) => (handleHoursInput('cwhd_work_hours', $event))),
                              onBlur: _cache[15] || (_cache[15] = ($event: any) => (onHoursBlur('cwhd_work_hours')))
                            }, null, 40, _hoisted_26)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _cache[90] || (_cache[90] = _createElementVNode("label", null, "연장", -1)),
                            _createElementVNode("input", {
                              value: form.value.cwhd_overtime_hours,
                              type: "text",
                              onInput: _cache[16] || (_cache[16] = ($event: any) => (handleHoursInput('cwhd_overtime_hours', $event))),
                              onBlur: _cache[17] || (_cache[17] = ($event: any) => (onHoursBlur('cwhd_overtime_hours')))
                            }, null, 40, _hoisted_27)
                          ]),
                          _createElementVNode("td", null, [
                            _cache[91] || (_cache[91] = _createElementVNode("label", null, "야간", -1)),
                            _createElementVNode("input", {
                              value: form.value.cwhd_night_hours,
                              type: "text",
                              onInput: _cache[18] || (_cache[18] = ($event: any) => (handleHoursInput('cwhd_night_hours', $event))),
                              onBlur: _cache[19] || (_cache[19] = ($event: any) => (onHoursBlur('cwhd_night_hours')))
                            }, null, 40, _hoisted_28)
                          ]),
                          _createElementVNode("td", null, [
                            _cache[92] || (_cache[92] = _createElementVNode("label", null, "휴일", -1)),
                            _createElementVNode("input", {
                              value: form.value.cwhd_holiday_hours,
                              type: "text",
                              onInput: _cache[20] || (_cache[20] = ($event: any) => (handleHoursInput('cwhd_holiday_hours', $event))),
                              onBlur: _cache[21] || (_cache[21] = ($event: any) => (onHoursBlur('cwhd_holiday_hours')))
                            }, null, 40, _hoisted_29)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _cache[106] || (_cache[106] = _createElementVNode("div", { class: "box-title" }, "수당 항목", -1)),
                    _createElementVNode("table", _hoisted_31, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _cache[93] || (_cache[93] = _createElementVNode("label", null, "연차", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.cwhd_dayoff) = $event)),
                              type: "text",
                              onInput: _cache[23] || (_cache[23] = ($event: any) => (onAmountInput('cwhd_dayoff')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_dayoff]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _cache[94] || (_cache[94] = _createElementVNode("label", null, "장기", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((form.value.cwhd_senior) = $event)),
                              type: "text",
                              onInput: _cache[25] || (_cache[25] = ($event: any) => (onAmountInput('cwhd_senior')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_senior]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _cache[95] || (_cache[95] = _createElementVNode("label", null, "선임", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((form.value.cwhd_sunim) = $event)),
                              type: "text",
                              onInput: _cache[27] || (_cache[27] = ($event: any) => (onAmountInput('cwhd_sunim')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_sunim]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _cache[96] || (_cache[96] = _createElementVNode("label", null, "상여", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((form.value.cwhd_bonus) = $event)),
                              type: "text",
                              onInput: _cache[29] || (_cache[29] = ($event: any) => (onAmountInput('cwhd_bonus')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_bonus]
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _cache[97] || (_cache[97] = _createElementVNode("label", null, "교육", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((form.value.cwhd_bosu) = $event)),
                              type: "text",
                              onInput: _cache[31] || (_cache[31] = ($event: any) => (onAmountInput('cwhd_bosu')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_bosu]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _cache[98] || (_cache[98] = _createElementVNode("label", null, "보존", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((form.value.cwhd_bojon) = $event)),
                              type: "text",
                              onInput: _cache[33] || (_cache[33] = ($event: any) => (onAmountInput('cwhd_bojon')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_bojon]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _cache[99] || (_cache[99] = _createElementVNode("label", null, "기타", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((form.value.cwhd_other) = $event)),
                              type: "text",
                              onInput: _cache[35] || (_cache[35] = ($event: any) => (onAmountInput('cwhd_other')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_other]
                            ])
                          ]),
                          _cache[100] || (_cache[100] = _createElementVNode("td", null, null, -1))
                        ]),
                        _createElementVNode("tr", _hoisted_32, [
                          _createElementVNode("td", null, [
                            _cache[101] || (_cache[101] = _createElementVNode("label", null, "당직", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((form.value.cwhd_dang) = $event)),
                              type: "text",
                              onInput: _cache[37] || (_cache[37] = ($event: any) => (onAmountInput('cwhd_dang')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_dang]
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: _normalizeClass({ 'lunch-error': lunchValidation.value && !lunchValidation.value.isValid })
                          }, [
                            _cache[102] || (_cache[102] = _createElementVNode("label", null, "중식비", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((form.value.cwhd_lunch) = $event)),
                              type: "text",
                              onInput: _cache[39] || (_cache[39] = ($event: any) => (onAmountInput('cwhd_lunch')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_lunch]
                            ])
                          ], 2),
                          _createElementVNode("td", null, [
                            _cache[103] || (_cache[103] = _createElementVNode("label", null, "차량", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((form.value.cwhd_car) = $event)),
                              type: "text",
                              onInput: _cache[41] || (_cache[41] = ($event: any) => (onAmountInput('cwhd_car')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_car]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _cache[104] || (_cache[104] = _createElementVNode("label", null, "양육", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((form.value.cwhd_child) = $event)),
                              type: "text",
                              onInput: _cache[43] || (_cache[43] = ($event: any) => (onAmountInput('cwhd_child')))
                            }, null, 544), [
                              [_vModelText, form.value.cwhd_child]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (lunchValidation.value && !lunchValidation.value.isValid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _cache[105] || (_cache[105] = _createElementVNode("span", { class: "warning-icon" }, "⚠", -1)),
                          _createElementVNode("span", _hoisted_34, _toDisplayString(lunchValidation.value.message), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[110] || (_cache[110] = _createElementVNode("span", { class: "result-title" }, "임금구성", -1)),
                    _createElementVNode("span", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, [
                        _cache[107] || (_cache[107] = _createTextVNode("임금합계 ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_wage_total)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_39, [
                        _cache[108] || (_cache[108] = _createTextVNode("과세 ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_taxable)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_40, [
                        _cache[109] || (_cache[109] = _createTextVNode("통상 ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_usual)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_41, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _cache[111] || (_cache[111] = _createElementVNode("span", null, "기본급", -1)),
                          (basicCalcMode.value === 'basic')
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                class: "result-basic-input",
                                value: _unref(formatWageNumber)(displayCalc.value.cwhd_basic),
                                disabled: saving.value || deleting.value,
                                onInput: _cache[44] || (_cache[44] = ($event: any) => (onCalcAmountInput('cwhd_basic', ($event.target as HTMLInputElement).value))),
                                onBlur: _cache[45] || (_cache[45] = ($event: any) => (onCalcAmountBlur('cwhd_basic', $event)))
                              }, null, 40, _hoisted_42))
                            : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_basic)), 1))
                        ]),
                        _createElementVNode("td", null, [
                          _cache[112] || (_cache[112] = _createElementVNode("span", null, "연장(과세)", -1)),
                          _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_overtime)), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[113] || (_cache[113] = _createElementVNode("span", null, "야간(과세)", -1)),
                          _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_night)), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[114] || (_cache[114] = _createElementVNode("span", null, "휴일(과세)", -1)),
                          _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_holiday)), 1)
                        ])
                      ]),
                      (settings.value.cwhd_production_nontax && (displayCalc.value.cwhd_overtime_nontax > 0 || displayCalc.value.cwhd_night_nontax > 0 || displayCalc.value.cwhd_holiday_nontax > 0))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                            _cache[118] || (_cache[118] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", null, [
                              _cache[115] || (_cache[115] = _createElementVNode("span", null, "연장(비과세)", -1)),
                              _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_overtime_nontax)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _cache[116] || (_cache[116] = _createElementVNode("span", null, "야간(비과세)", -1)),
                              _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_night_nontax)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _cache[117] || (_cache[117] = _createElementVNode("span", null, "휴일(비과세)", -1)),
                              _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_holiday_nontax)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _cache[119] || (_cache[119] = _createElementVNode("span", null, "연차수당", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_dayoff || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[120] || (_cache[120] = _createElementVNode("span", null, "장기근속", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_senior || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[121] || (_cache[121] = _createElementVNode("span", null, "선임수당", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_sunim || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[122] || (_cache[122] = _createElementVNode("span", null, "상여금", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_bonus || '0'), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _cache[123] || (_cache[123] = _createElementVNode("span", null, "교육비", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_bosu || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[124] || (_cache[124] = _createElementVNode("span", null, "보존수당", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_bojon || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[125] || (_cache[125] = _createElementVNode("span", null, "기타수당", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_other || '0'), 1)
                        ]),
                        _cache[126] || (_cache[126] = _createElementVNode("td", null, null, -1))
                      ]),
                      _createElementVNode("tr", _hoisted_45, [
                        _createElementVNode("td", null, [
                          _cache[127] || (_cache[127] = _createElementVNode("span", null, "당직수당", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_dang || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[128] || (_cache[128] = _createElementVNode("span", null, "중식비", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_lunch || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[129] || (_cache[129] = _createElementVNode("span", null, "차량보조비", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_car || '0'), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _cache[130] || (_cache[130] = _createElementVNode("span", null, "양육비", -1)),
                          _createElementVNode("span", null, _toDisplayString(form.value.cwhd_child || '0'), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[145] || (_cache[145] = _createElementVNode("div", { class: "box-title" }, [
                        _createElementVNode("span", null, "근로자 공제")
                      ], -1)),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("label", _hoisted_51, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.yeon,
                              onChange: _cache[46] || (_cache[46] = ($event: any) => (onManualFlagChange('yeon', $event)))
                            }, null, 40, _hoisted_52),
                            _cache[131] || (_cache[131] = _createElementVNode("span", null, "국민연금", -1)),
                            (ageInsurance.value.pensionExempt && ageInsurance.value.age !== null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, "만 " + _toDisplayString(ageInsurance.value.age) + "세 면제", 1))
                              : (ageInsurance.value.age !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_54, "만 " + _toDisplayString(ageInsurance.value.age) + "세 자동적용", 1))
                                : _createCommentVNode("", true)
                          ]),
                          (manualFlags.value.yeon)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "number",
                                class: "deduct-input",
                                value: deductForm.value.cwhd_l_yeon,
                                onInput: _cache[47] || (_cache[47] = ($event: any) => (onDeductInput('cwhd_l_yeon', $event))),
                                onBlur: _cache[48] || (_cache[48] = ($event: any) => (onDeductBlur('cwhd_l_yeon', $event)))
                              }, null, 40, _hoisted_55))
                            : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(ageInsurance.value.pensionExempt ? '0 (60세 이상 면제)' : _unref(formatWageNumber)(displayCalc.value.cwhd_l_yeon)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("label", _hoisted_58, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.gun,
                              onChange: _cache[49] || (_cache[49] = ($event: any) => (onManualFlagChange('gun', $event)))
                            }, null, 40, _hoisted_59),
                            _cache[132] || (_cache[132] = _createElementVNode("span", null, "건강보험", -1))
                          ]),
                          (manualFlags.value.gun)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "number",
                                class: "deduct-input",
                                value: deductForm.value.cwhd_l_gun,
                                onInput: _cache[50] || (_cache[50] = ($event: any) => (onDeductInput('cwhd_l_gun', $event))),
                                onBlur: _cache[51] || (_cache[51] = ($event: any) => (onDeductBlur('cwhd_l_gun', $event)))
                              }, null, 40, _hoisted_60))
                            : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_gun)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("label", _hoisted_63, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.jang,
                              onChange: _cache[52] || (_cache[52] = ($event: any) => (onManualFlagChange('jang', $event)))
                            }, null, 40, _hoisted_64),
                            _cache[133] || (_cache[133] = _createElementVNode("span", null, "장기요양", -1))
                          ]),
                          (manualFlags.value.jang)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "number",
                                class: "deduct-input",
                                value: deductForm.value.cwhd_l_jang,
                                onInput: _cache[53] || (_cache[53] = ($event: any) => (onDeductInput('cwhd_l_jang', $event))),
                                onBlur: _cache[54] || (_cache[54] = ($event: any) => (onDeductBlur('cwhd_l_jang', $event)))
                              }, null, 40, _hoisted_65))
                            : (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_jang)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.l_go,
                              onChange: _cache[55] || (_cache[55] = ($event: any) => (onManualFlagChange('l_go', $event)))
                            }, null, 40, _hoisted_69),
                            _cache[134] || (_cache[134] = _createElementVNode("span", null, "고용보험", -1)),
                            _cache[135] || (_cache[135] = _createElementVNode("span", { class: "deduct-side-chip deduct-side-chip--labor" }, "근로", -1)),
                            (ageInsurance.value.employmentExempt && ageInsurance.value.age !== null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, "만 " + _toDisplayString(ageInsurance.value.age) + "세 면제", 1))
                              : _createCommentVNode("", true)
                          ]),
                          (manualFlags.value.l_go)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((deductForm.value.cwhd_l_go) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_l_go,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(ageInsurance.value.employmentExempt ? '0 (65세 이상 면제)' : _unref(formatWageNumber)(displayCalc.value.cwhd_l_go)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("label", _hoisted_73, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.c_go,
                              onChange: _cache[57] || (_cache[57] = ($event: any) => (onManualFlagChange('c_go', $event)))
                            }, null, 40, _hoisted_74),
                            _cache[136] || (_cache[136] = _createElementVNode("span", null, "고용보험", -1)),
                            _cache[137] || (_cache[137] = _createElementVNode("span", { class: "deduct-side-chip deduct-side-chip--corp" }, "기관", -1)),
                            (settings.value.cwhd_is_owner)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, "대표자 면제"))
                              : _createCommentVNode("", true)
                          ]),
                          (manualFlags.value.c_go)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((deductForm.value.cwhd_c_go) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_c_go,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(settings.value.cwhd_is_owner ? '0 (대표자 면제)' : _unref(formatWageNumber)(displayCalc.value.cwhd_c_go)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("label", _hoisted_78, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.l_so,
                              onChange: _cache[59] || (_cache[59] = ($event: any) => (onManualFlagChange('l_so', $event)))
                            }, null, 40, _hoisted_79),
                            _cache[138] || (_cache[138] = _createElementVNode("span", null, "소득세", -1))
                          ]),
                          (manualFlags.value.l_so)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((deductForm.value.cwhd_l_so) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_l_so,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_so)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("label", _hoisted_82, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.l_ji,
                              onChange: _cache[61] || (_cache[61] = ($event: any) => (onManualFlagChange('l_ji', $event)))
                            }, null, 40, _hoisted_83),
                            _cache[139] || (_cache[139] = _createElementVNode("span", null, "지방세", -1))
                          ]),
                          (manualFlags.value.l_ji)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((deductForm.value.cwhd_l_ji) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_l_ji,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_ji)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("label", _hoisted_86, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.l_jiwon,
                              onChange: _cache[63] || (_cache[63] = ($event: any) => (onManualFlagChange('l_jiwon', $event)))
                            }, null, 40, _hoisted_87),
                            _cache[140] || (_cache[140] = _createElementVNode("span", null, "지원공제", -1))
                          ]),
                          (manualFlags.value.l_jiwon)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((deductForm.value.cwhd_l_jiwon) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_l_jiwon,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_jiwon)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("label", _hoisted_90, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.l_sik,
                              onChange: _cache[65] || (_cache[65] = ($event: any) => (onManualFlagChange('l_sik', $event)))
                            }, null, 40, _hoisted_91),
                            _cache[141] || (_cache[141] = _createElementVNode("span", null, "중식비공제", -1))
                          ]),
                          (manualFlags.value.l_sik)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((deductForm.value.cwhd_l_sik) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_l_sik,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_sik)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _cache[142] || (_cache[142] = _createElementVNode("label", { class: "deduct-label deduct-label--manual-only" }, [
                            _createElementVNode("span", null, "기타공제")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((deductForm.value.cwhd_l_etc) = $event)),
                            type: "number",
                            class: "deduct-input",
                            placeholder: "0"
                          }, null, 512), [
                            [
                              _vModelText,
                              deductForm.value.cwhd_l_etc,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _cache[143] || (_cache[143] = _createElementVNode("label", { class: "deduct-label deduct-label--manual-only" }, [
                            _createElementVNode("span", null, "연말정산")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((deductForm.value.cwhd_l_yearend) = $event)),
                            type: "number",
                            class: "deduct-input",
                            placeholder: "0"
                          }, null, 512), [
                            [
                              _vModelText,
                              deductForm.value.cwhd_l_yearend,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _cache[144] || (_cache[144] = _createElementVNode("span", null, "합계", -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_total)) + "원", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _cache[150] || (_cache[150] = _createElementVNode("div", { class: "box-title" }, [
                        _createElementVNode("span", null, "기관 공제")
                      ], -1)),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("label", _hoisted_99, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.c_sil,
                              onChange: _cache[69] || (_cache[69] = ($event: any) => (onManualFlagChange('c_sil', $event)))
                            }, null, 40, _hoisted_100),
                            _cache[146] || (_cache[146] = _createElementVNode("span", null, "실업급여", -1))
                          ]),
                          (manualFlags.value.c_sil)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((deductForm.value.cwhd_c_sil) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_c_sil,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(settings.value.cwhd_is_owner ? '0 (대표자 면제)' : _unref(formatWageNumber)(displayCalc.value.cwhd_c_sil)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("label", _hoisted_103, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.c_san,
                              onChange: _cache[71] || (_cache[71] = ($event: any) => (onManualFlagChange('c_san', $event)))
                            }, null, 40, _hoisted_104),
                            _cache[147] || (_cache[147] = _createElementVNode("span", null, "산재보험", -1))
                          ]),
                          (manualFlags.value.c_san)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((deductForm.value.cwhd_c_san) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_c_san,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(settings.value.cwhd_is_owner ? '0 (대표자 면제)' : _unref(formatWageNumber)(displayCalc.value.cwhd_c_san)), 1))
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("label", _hoisted_107, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !!manualFlags.value.c_out,
                              onChange: _cache[73] || (_cache[73] = ($event: any) => (onManualFlagChange('c_out', $event)))
                            }, null, 40, _hoisted_108),
                            _cache[148] || (_cache[148] = _createElementVNode("span", null, "퇴직금", -1))
                          ]),
                          (manualFlags.value.c_out)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((deductForm.value.cwhd_c_out) = $event)),
                                type: "number",
                                class: "deduct-input"
                              }, null, 512)), [
                                [
                                  _vModelText,
                                  deductForm.value.cwhd_c_out,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(settings.value.cwhd_is_owner ? '0 (대표자 면제)' : _unref(formatWageNumber)(displayCalc.value.cwhd_c_out)), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_110, [
                        _cache[149] || (_cache[149] = _createElementVNode("span", null, "합계", -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_c_total)) + "원", 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _cache[151] || (_cache[151] = _createElementVNode("div", { class: "box-title" }, "메모", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((form.value.cwhd_memo) = $event)),
                    rows: "2",
                    placeholder: "메모 입력",
                    class: "memo-textarea"
                  }, null, 512), [
                    [_vModelText, form.value.cwhd_memo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_112, [
                  _createElementVNode("div", _hoisted_113, [
                    _cache[152] || (_cache[152] = _createElementVNode("span", null, "임금합계", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_wage_total)) + "원", 1)
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _cache[153] || (_cache[153] = _createElementVNode("span", null, "공제합계", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.cwhd_l_total)) + "원", 1)
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _cache[154] || (_cache[154] = _createElementVNode("span", null, "실수령액", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatWageNumber)(displayCalc.value.netPay)) + "원", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  (currentRow.value?.cwhd_idx)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn-delete-inline",
                        disabled: saving.value || deleting.value,
                        onClick: onDelete
                      }, " 삭제 ", 8, _hoisted_118))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-save",
                    disabled: saving.value,
                    onClick: onSave
                  }, _toDisplayString(saving.value ? '저장 중...' : '저장'), 9, _hoisted_120),
                  (!__props.inline)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn-close",
                        onClick: _cache[76] || (_cache[76] = ($event: any) => (emit('close')))
                      }, "닫기"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]),
      _: 1
    }, 16)),
    _createVNode(HomeWageDeductionFixModal, {
      modelValue: showDeductionFixModal.value,
      "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((showDeductionFixModal).value = $event)),
      title: deductionFixModalTitle.value,
      "has-auto-preview": deductionFixModalPreview.value.hasAuto,
      "auto-amount": deductionFixModalPreview.value.nominal,
      "auto-label": deductionFixAutoLabel.value,
      "auto-button-label": deductionFixAutoButtonLabel.value,
      "auto-hint": deductionFixAutoHint.value,
      "applied-amount": deductionFixAppliedAmount.value,
      "applied-notes": deductionFixModalPreview.value.notes,
      formula: deductionFixModalPreview.value.formula,
      "current-amount": deductionFixModalCurrentAmount.value,
      "has-current-amount": deductionFixModalHasCurrent.value,
      "manual-label": "직접 입력",
      "manual-display": deductionFixModalManualDisplay.value,
      "input-id": "common-wage-deduction-fix-manual",
      "format-money": _unref(formatWageNumber),
      onCancel: cancelDeductionFixModal,
      onApplyAuto: applyDeductionFixModalNominal,
      onApplyApplied: applyDeductionFixModalApplied,
      onApplyManual: applyDeductionFixModalManual,
      onManualInput: onDeductionFixModalManualInput
    }, null, 8, ["modelValue", "title", "has-auto-preview", "auto-amount", "auto-label", "auto-button-label", "auto-hint", "applied-amount", "applied-notes", "formula", "current-amount", "has-current-amount", "manual-display", "format-money"])
  ], 64))
}
}

})